// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const OpenPipsSummaryItem = props =>
    <li className='open-pips-summary-list-item'>
        <div className='count'>{props.count}</div>
        <div className='status'>
            <FormattedMessage id={props.status}/>
        </div>
        <div className='status-indicator'>
            <span className={props.className}/>
        </div>
    </li>;

OpenPipsSummaryItem.displayName = 'OpenPipsSummaryItem';
OpenPipsSummaryItem.propTypes = {
    className: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired
};

export default OpenPipsSummaryItem;



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-aside/open-pips-summary/open-pips-summary-item.js